<template>
  <div class="download-container" :class="wxClass">
    <div class="title-container">
      <img class="logo" src="../assets/icon/link_icon.png" />
      <!-- <p class="sub-title-h1">IM智己拓展屏</p> -->
      <p class="title-h1">在路上，发现智己</p>
    </div>
    <div class="detail-container">
      <a href="cockpitbuddy://home" ref="downloadAndroid" @click="toAndriodApp">
        <img
          v-show="uaInfo.isTablet && uaInfo.isAndroid"
          class="button-img"
          src="../assets/icon/link_android.png"
        />
      </a>
      <a href="https://apps.apple.com/app/id6504503512"
        v-show="uaInfo.isTablet && uaInfo.isIOS"
        v-if="iosInstore"
      >
        <img
          class="button-img"
          src="../assets/icon/link_ios.png"
        />
      </a>
      <span
        class="desc-phone"
        v-show="
          !uaInfo.isTablet ||
          (uaInfo.isTablet &&
            !uaInfo.isAndroid &&
            !uaInfo.isIOS &&
            !uaInfo.isHarmony)
        "
        >请使用Pad设备扫描后下载/打开</span
      >
      <span
        class="desc"
        v-show="
          uaInfo.isTablet &&
          (uaInfo.isAndroid || uaInfo.isIOS || uaInfo.isHarmony)
        "
        >{{uaInfo.isIOS ? iosInstore ? '可拓展移动智能体验，下载App，发现更多精彩' : '即将开放下载，敬请期待！' : '可拓展移动智能体验，下载App，发现更多精彩'}}</span>
    </div>
    <div class="middle-layer">
      <span class="arrow-desc">点击右上角，选择浏览器打开</span>
      <img class="arrow-img" src="../assets/icon/arrow.png" />
    </div>
  </div>
</template>

<script>
import device from "current-device";

export default {
  name: "DownloadApp",
  components: {
  },
  data() {
    return {
      uaInfo: {},
      wxClass: "",
      iosInstore: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  watch: {
    isCreate() {
      this.$nextTick(() => {
        this.init();
      });
    },
  },
  methods: {
    toAndriodApp() {
      if (this.uaInfo.isAndroidOrHarmony) {
        if (this.uaInfo.isWx) {
          alert("点击右上角使用外部浏览器打开");
          return;
        }
        const start = Date.now();
        const LOAD_WAITING = 2000;
        const loadTimer = setTimeout(() => {
          if (document.hidden || document.webkitHidden) {
            return;
          }
          if (Date.now() - start < LOAD_WAITING + 200) {
            window.location.href = process.env.VUE_APP_ANDROIDAPK;
          }
        }, LOAD_WAITING);
        const visibilityChange = () => {
          const tag = document.hidden || document.webkitHidden;
          tag && clearTimeout(loadTimer);
        };
        document.addEventListener("visibilitychange", visibilityChange, false);
        document.addEventListener(
          "webkitvisibilitychange",
          visibilityChange,
          false
        );
        window.addEventListener(
          "pagehide",
          () => {
            clearTimeout(loadTimer);
          },
          false
        );
      }
    },
    init() {
      console.log(process.env)
      document.title = "IM Link";
      this.iosInstore = process.env.VUE_APP_IOSINSTORE
      const ua = navigator.userAgent;
      const isAndroid = () => /Android|Adr|XiaoMi/i.test(ua);
      const isIOS = () => /iPhone|iPad|iPod|Mac OS/i.test(ua);
      const isHarmony = () => /Harmony/i.test(ua);
      const isWx = () => /micromessenger/i.test(ua);
      const isQQBrowser = () => /QQBrowser/i.test(ua);
      const isAndroidOrHarmony = () => isAndroid() || isHarmony();
      const isAndroidOrHarmonyChrome = () =>
        (/Chrome\/([\d.]+)/i.test(ua) || /CriOS\/([\d.]+)/i.test(ua)) &&
        isAndroidOrHarmony();

      let cwidth = document.documentElement.clientWidth || document.body.clientWidth;

      let isTablet = device.type == "tablet" || device.ipad();
      const density = window.devicePixelRatio;
      if (!isTablet && cwidth >= 640 && density > 1.5) {
        // 兼容
        if (isAndroid()) {
          isTablet = true;
        }
      }
      let isAnd = isAndroid()
      let isAndOrHarmony = isAndroidOrHarmony()
      if(!isAndroid() && !isIOS() && !isHarmony() && cwidth >= 640 && density > 1.5) {
          isTablet = true;
          isAnd = true
          isAndOrHarmony = true
       }
       console.log(cwidth, density)
      this.uaInfo = {
        isAndroid: isAnd,
        isIOS: isIOS(),
        isHarmony: isHarmony(),
        isWx: isWx(),
        isAndroidOrHarmony: isAndOrHarmony,
        isAndroidOrHarmonyChrome: isAndroidOrHarmonyChrome(),
        isTablet: isTablet,
        isWidth768: cwidth >= 640,
        isQQBrowser: isQQBrowser(),
      };

      if (isWx() && isAndroid() && this.uaInfo.isTablet) {
        this.wxClass = "is-wx";
      }

      console.log(this.uaInfo);

      console.log(device);
      
      for (const key in device) {
        if (typeof device[key] === "function") {
          console.log(key, device[key]());
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: 'PingFang SC';
}
.download-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
}

.detail-container,
.title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title-container {
  height: 60%;
  margin-bottom: 10%;
}

.detail-container {
  height: 30%;
}

.logo {
  height: 140px;
  // border-radius: 20px;
}

.sub-title-h1 {
  height: 18px;
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
  font-family: "PingFang SC";
}

.title-h1 {
  font-size: 24px;
  font-weight: 300;
  color: #000;
  line-height: 29px;
  margin-top: 20px;
}

.button {
  text-decoration: none;
  background-color: transparent;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

.button-img {
  height: 48px;
}

.desc {
  font-size: 12px;
  font-weight: 400;
  color: #666;
  line-height: 15px;
  margin-top: 15px;
}
.desc-phone {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.8px;
  text-align: center;
}

.middle-layer {
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}

.arrow-desc,
.arrow-img {
  position: absolute;
}

.arrow-desc {
  top: 82px;
  right: 114px;
  font-weight: 600;
  color: #fff;
  line-height: 19px;
}

.arrow-img {
  height: 84px;
  top: 8px;
  right: 21px;
}

.is-wx .middle-layer {
  visibility: visible;
}

.is-wx .detail-container {
  display: none;
}
</style>
